/**
 *
 * @param content 현재 운송 상태 state
 * @param transportationType 운송 타입 (1: 왕복 2: 편도, 3: 셔틀)
 * @returns
 */
export const transportationTranslaterToString = (
  content: string,
  transportationType?: number
): string => {
  if (transportationType === 1) {
    if (content === "EN_ROUTE_TO_LOADING_POINT") {
      return "상차지 이동";
    } else if (content === "LOADING_COMPLETED") {
      return "상차 완료";
    } else if (content === "EN_ROUTE_TO_WORK_POINT") {
      return "작업지 이동";
    } else if (content === "WORK_COMPLETED") {
      return "작업 완료";
    } else if (content === "EN_ROUTE_TO_UNLOADING_POINT") {
      return "하차지 이동";
    } else if (content === "UNLOADING_COMPLETED") {
      return "하차 완료";
    } else if (content === "TRANSPORTATION_CANCEL_REQUEST") {
      return "운송 취소 요청 중";
    } else {
      return "상태 확인중...";
    }
  } else {
    if (content === "EN_ROUTE_TO_LOADING_POINT") {
      return "상차지 이동";
    } else if (content === "LOADING_COMPLETED") {
      return "상차 완료";
    } else if (content === "EN_ROUTE_TO_UNLOADING_POINT") {
      return "하차지 이동";
    } else if (content === "UNLOADING_COMPLETED") {
      return "하차 완료";
    } else {
      return "상태 확인중...";
    }
  }
};

export const transportationTranslaterToNumber = (
  content: string,
  transportationType?: number
): number => {
  // 왕복일때
  if (transportationType === 1) {
    if (content === "EN_ROUTE_TO_LOADING_POINT") {
      return 1;
    } else if (content === "LOADING_COMPLETED") {
      return 2;
    } else if (content === "EN_ROUTE_TO_WORK_POINT") {
      return 3;
    } else if (content === "WORK_COMPLETED") {
      return 4;
    } else if (content === "EN_ROUTE_TO_UNLOADING_POINT") {
      return 5;
    } else if (content === "UNLOADING_COMPLETED") {
      return 6;
    } else {
      return 6;
    }
  } else {
    if (content === "EN_ROUTE_TO_LOADING_POINT") {
      return 1;
    } else if (content === "LOADING_COMPLETED") {
      return 2;
    } else if (content === "EN_ROUTE_TO_UNLOADING_POINT") {
      return 3;
    } else if (content === "UNLOADING_COMPLETED") {
      return 4;
    } else {
      return 4;
    }
  }
};
